module.exports = __webpack_public_path__ + "static/media/VRQ-White.7da7599b.png";